import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SwaggerUi from 'swagger-ui';
import * as Auth from 'aws-amplify/auth';

import 'swagger-ui/dist/swagger-ui.css';

class SwaggerUI extends Component {
  async componentDidMount() {
    const {
      url = 'v1/swagger.json',
      spec,
    } = this.props;

    const ui = SwaggerUi({
      dom_id: '#swaggerContainer',
      syntaxHighlight: false,
      url,
      spec,
      presets: [SwaggerUi.presets.apis],
    });

    const session = await Auth.fetchAuthSession();
    const JWTAuth = session.tokens?.idToken?.toString();

    ui.preauthorizeApiKey('ApiKeyAuth', process.env.API_KEY);
    ui.preauthorizeApiKey('JWTAuth', JWTAuth);
  }

  render() {
    return (
      <div id="swaggerContainer" />
    );
  }
}

SwaggerUI.propTypes = {
  url: PropTypes.string,
  // eslint-disable-next-line react/require-default-props,react/forbid-prop-types
  spec: PropTypes.object,
};

export default SwaggerUI;
